import likedUsersActions from "./liked-users/actions"
import ApiService, { FileService } from "@/base/api/api.service"
import router from '@/router'

import {
    CREATE_POST,
    CREATE_ATTACHMENT,
    GET_POST,
    GET_POST_LIST,
    DEL_POST,
    DEL_ATTACHMENT,
    GET_POST_ATTACHMENTS,
    GET_ATTACHMENT,
    CURRENT_POST_CLEAR,
    LIKE_POST,
    UNLIKE_POST,
    UPDATE_POST_CONTENT,
    UPDATE_POST_ATTACHMENT,
    BOOKMARK_POST,
    DEL_BOOKMARK_POST
} from "@/store/actions.type"

import {
    CLEAR_CURRENT_POST,
    CLEAR_FILES,
    CLEAR_POST_LIST,
    CREATING_POST,
    SET_CURRENT_POST,
    SET_ERROR,
    CURRENT_POST_LOADING,
    POST_LIST_LOADING,
    SET_ATTACHMENTS_LOADING,
    SET_ATTACHMENT_OFFSET,
    PUSH_POST,
    ADD_FILE,
    UPDATE_FILE,
    REMOVE_FILE,
    SET_SINGLE_ATTACHMENT_LOADING,
    UPDATE_POST
} from "@/store/mutations.type"

import {
    POST_UPLOADS,
    POST_ATTACHMENTS
} from '@/store/media.type'

import {
    CREATE_POST_URL,
    GET_POST_URL
} from "@/base/api/config";
import { CommetService } from "@/base/api/api.service"

export default {

    // Creating post
    [CREATE_POST]({ commit }, payload) {
        commit(CREATING_POST, true)
        const postData = {
            title: payload.title,
            description: payload.description
        }

        postData.attachments = []

        payload.attachments.forEach((attachment) => {
            const attachmentData = {
                title: attachment.title || '',
                description: attachment.description || '',
                file_url: attachment.file_url_firebase || attachment.file_url,
                thumbnail_file_url: attachment.thumbnail_url_firebase || attachment.thumbnail_url,
                file_name: attachment.file_name,
                thumbnail_file_name: attachment.thumbnail.name
            }
            postData.attachments.push(attachmentData)
        })

        let postId = null

        ApiService.post(`/${CREATE_POST_URL}`, postData)
            .then(res => {
                postId = res.data.id

                // when a new post is created
                return CommetService.createGroup({
                    id: "post" + postId,
                    name: "post" + postId
                })

            })
            .then(() => {
                commit(CREATING_POST, false)
                commit(CLEAR_FILES, POST_UPLOADS)
                router.push(`/post/${postId}`)
            })
            .catch(err => {
                commit(SET_ERROR, err.data)
                commit(CREATING_POST, false)
            })
    },

    // Getting single post
    [GET_POST]({ commit }, postId) {
        commit(CURRENT_POST_LOADING, true)
        ApiService.get(GET_POST_URL, postId)
            .then(res => {
                commit(CURRENT_POST_LOADING, false)
                commit(SET_CURRENT_POST, res.data.post)
            })
            .catch(error => {
                commit(CURRENT_POST_LOADING, false)
                commit(SET_ERROR, error.data)
            })
    },

    // Deleting post
    async [DEL_POST]({ commit }, postId) {
        try {
            await ApiService.delete(GET_POST_URL, `${postId}`)
            commit(CLEAR_POST_LIST)
            router.push('/')
        } catch (err) {
            commit(SET_ERROR, err.data)
        }
    },

    // Getting Post attachemts for gallery
    [GET_POST_ATTACHMENTS]({ commit, state }, payload) {
        commit(SET_ATTACHMENTS_LOADING, true)
        ApiService.get(GET_POST_URL, `${payload.postId}/attachments/list?offset=${state.attachmentsOffset}&limit=${state.attachmentsLimit}`)
            .then(res => {
                commit(SET_ATTACHMENTS_LOADING, false)
                let attachments = res.data.attachments
                commit(SET_ATTACHMENT_OFFSET, attachments.length)
                attachments.forEach((attachment) => {
                    attachment.type = POST_ATTACHMENTS
                    attachment.user = payload.userDetails
                    attachment.uploaded = true
                    attachment.deleting = false
                    commit(ADD_FILE, attachment)
                })
            })
            .catch(err => {
                commit(SET_ATTACHMENTS_LOADING, false)
                commit(SET_ERROR, err.data)
            })
    },

    // Get file attachment
    [GET_ATTACHMENT]({ commit, getters }, payload) {
        const photoAttachments = getters.getPhotos(POST_ATTACHMENTS)
        if (photoAttachments.findIndex(photo => photo.id === +payload.attachmentId) !== -1) return
        commit(SET_SINGLE_ATTACHMENT_LOADING, true)
        ApiService.get(GET_POST_URL, `${payload.postId}/attachment/${payload.attachmentId}`)
            .then(res => {
                commit(SET_SINGLE_ATTACHMENT_LOADING, false)
                const attachment = res.data.attachment
                attachment.type = POST_ATTACHMENTS
                commit(ADD_FILE, attachment)
            })
            .catch(err => {
                commit(SET_SINGLE_ATTACHMENT_LOADING, false)
                commit(SET_ERROR, err.data)
            })
    },

    // Creating attachment
    [CREATE_ATTACHMENT]({ commit, state }, payload) {
        commit(ADD_FILE, {
            uploaded: false,
            uploadProgress: 0,
            deleting: false,
            user: state.currentPost.user,
            ...payload.photo
        })
        const uploading = FileService.uploadFile(payload.photo, (snapshot) => {
            let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            commit(UPDATE_FILE, {
                id: payload.photo.id,
                values: {
                    uploadProgress: Math.round(progress)
                }
            })
        })
        uploading.then((urls) => {
                commit(UPDATE_FILE, {
                    id: payload.photo.id,
                    values: {
                        file_url_firebase: urls[0],
                        thumbnail_url_firebase: urls[1]
                    }
                })

                return ApiService.post(`${GET_POST_URL}/${payload.postId}/attachment`, {
                    file_url: urls[0],
                    thumbnail_file_url: urls[1],
                    title: '',
                    description: '',
                    file_name: payload.photo.file_name,
                    thumbnail_file_name: payload.photo.thumbnail.name
                })
            })
            .then(res => {
                commit(UPDATE_FILE, {
                    id: payload.photo.id,
                    values: {
                        uploaded: true,
                        ...res.data
                    }
                })
            })
    },

    // Delete attachment
    [DEL_ATTACHMENT]({ commit, rootState }, payload) {
        const file = rootState.media.photos.find(photo => photo.id === payload.attachmentId)
        commit(UPDATE_FILE, {
            id: payload.attachmentId,
            values: {
                deleting: true
            }
        })
        FileService.deleteFile(file)
            .then(() => {
                return ApiService.delete(GET_POST_URL, `${payload.postId}/attachment/${payload.attachmentId}`)
            })
            .then(() => {
                commit(REMOVE_FILE, payload.attachmentId)
            })
    },

    // Getting post list 
    [GET_POST_LIST]({ commit, state }) {
        commit(POST_LIST_LOADING, true)
        ApiService.get(GET_POST_URL, `list?offset=${state.postListOffset}&limit=${state.postListLimit}`)
            .then(res => {
                commit(POST_LIST_LOADING, false)
                commit(PUSH_POST, res.data.posts)
            })
            .catch(err => {
                commit(POST_LIST_LOADING, false)
                commit(SET_ERROR, err.data)
            })
    },

    /* eslint-disable */
    async [UPDATE_POST_CONTENT]({ commit }, payload) {
        await ApiService.patch(`${GET_POST_URL}/${payload.postId}`, {
            title: payload.title,
            description: payload.description
        })
    },

    async [UPDATE_POST_ATTACHMENT]({}, payload) {
        await ApiService.patch(`${GET_POST_URL}/${payload.postId}/attachment/${payload.attachmentId}`, {
            title: payload.title,
            description: payload.description
        })
    },

    // Like or unlike post
    [LIKE_POST]({ commit }, payload) {
        commit(UPDATE_POST, {
            postId: payload.postId,
            values: {
                liked: true,
                likes_count: payload.likes_count
            }
        })
        ApiService.post(`${GET_POST_URL}/${payload.postId}/like`)
            .error(() => {
                commit(UPDATE_POST, {
                    postId: payload.postId,
                    values: {
                        liked: false,
                        likes_count: payload.likes_count - 1
                    }
                })
            })
    },

    [UNLIKE_POST]({ commit }, payload) {
        commit(UPDATE_POST, {
            postId: payload.postId,
            values: {
                liked: false,
                likes_count: payload.likes_count
            }
        })
        ApiService.delete(`${GET_POST_URL}/${payload.postId}/like`)
            .error(() => {
                commit(UPDATE_POST, {
                    postId: payload.postId,
                    values: {
                        liked: true,
                        likes_count: payload.likes_count + 1
                    }
                })
            })
    },

    // Bookmarks
    async [BOOKMARK_POST]({ commit }, payload) {
        await ApiService.post(`${GET_POST_URL}/${payload.postId}/bookmark`)
        commit(UPDATE_POST, {
            postId: payload.postId,
            values: {
                saved: true,
            }
        })
    },

    async [DEL_BOOKMARK_POST]({ commit }, payload) {
        await ApiService.delete(`${GET_POST_URL}/${payload.postId}/bookmark`)
        commit(UPDATE_POST, {
            postId: payload.postId,
            values: {
                saved: false,
            }
        })
    },

    // Resetting current post
    [CURRENT_POST_CLEAR]({ commit }) {
        commit(CLEAR_CURRENT_POST)
        commit(CLEAR_FILES, POST_ATTACHMENTS)
    },

    ...likedUsersActions
}